<!-- 物理因素接触限值紫外辐射 -->
<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]">工作场所紫外辐射职业接触限值</h5>
    <el-table :class="{mobileTable:$isMobile}" :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="sort" label="紫外光谱分类">
      </el-table-column>
      <el-table-column align="center" label="8h职业接触限值">
        <el-table-column align="center" label="辐照度（μW/cm2）">
          <template slot='header'>
            <span>辐照度（μW/cm</span>
            <sup>2</sup>
            <span>)</span>
          </template>
          <template slot-scope="scope">
            <p>{{scope.row.touchLimit.irradiance}}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="照射量（mJ/cm2）">
          <template slot='header'>
            <span>照射量（mJ/cm</span>
            <sup>2</sup>
            <span>)</span>
          </template>
          <template slot-scope="scope">
            <p>{{scope.row.touchLimit.exposureDose}}</p>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: [],
      }
    },
    created() {
      this.findUltravioletRadiation()
    },
    methods: {
      async findUltravioletRadiation(){
        let res = await this.$axios.get(this.$serviceAPI.findUltravioletRadiation)
        this.tableData = res.data.data
      }
    },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/ultravioletRadiation.vue